import { gql, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import CustomAutocomplete from '../CustomAutocomplete';

export const OBJECTS_QUERY = gql`
  query listDevices($filter: ObjectFilter, $first: Int) {
    objects(orderBy: NAME_ASC, filter: $filter, first: $first) {
      id
      name
    }
  }
`;

const objectsAutocomplete = (props) => {
  const [objects, setObjects] = useState([]);
  const [value, setValue] = useState(props.objectId);

  const [objectsLoad, objectsResult] = useLazyQuery(OBJECTS_QUERY, {
    onCompleted: (e) => {
      setObjects(e.objects.map((item) => ({ value: item.id, title: item.name })));
    },
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        schemaId: {
          equalTo: props.schemaId,
        },
        enabled: {
          equalTo: true,
        },
      },
    },
  });

  useEffect(() => {
    if (props.schemaId) {
      objectsLoad();
    }
  }, [props.schemaId]);

  const handleChange = (e) => {
    setValue(e.target.value || null);
    props.handleChange(e);
  };

  return (
    <>
      <CustomAutocomplete
        clearFieldIcon={true}
        error={props.error}
        helperText={props.helperText}
        autoComplete
        name={props.name}
        disabled={!props.schemaId}
        label={'Object name'}
        list={objects}
        value={value}
        loading={objectsResult.loading}
        onChange={handleChange}
        required={!!props.required}
      />
    </>
  );
};

export default objectsAutocomplete;
